import { NavLink } from "react-router-dom";
import { Flame, Heart, Calendar, User, MessageSquare } from "lucide-react";

export default function BottomNav() {
  const items = [
    { to: "/discover", label: "Discover", icon: Flame, testid: "nav-discover" },
    { to: "/matches", label: "Matches", icon: Heart, testid: "nav-matches" },
    { to: "/fixtures", label: "Fixtures", icon: Calendar, testid: "nav-fixtures" },
    { to: "/banter", label: "Banter", icon: MessageSquare, testid: "nav-banter" },
    { to: "/profile", label: "Profile", icon: User, testid: "nav-profile" },
  ];
  return (
    <nav
      className="fixed bottom-0 inset-x-0 bg-footy-card/95 backdrop-blur-xl border-t border-white/10 z-50"
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
      data-testid="bottom-nav"
    >
      <div className="max-w-md mx-auto h-20 flex justify-around items-center px-4">
        {items.map(({ to, label, icon: Icon, testid }) => (
          <NavLink key={to} to={to} data-testid={testid}
            className={({ isActive }) => `flex flex-col items-center gap-1 text-[11px] font-semibold transition-colors ${isActive ? "text-footy-red" : "text-slate-400 hover:text-white"}`}>
            <Icon size={20} strokeWidth={2.2} />
            <span>{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
